module.exports = __webpack_public_path__ + "img/2b22a10.jpg";